import {ChangeDetectorRef, HostBinding,Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {IRule} from '../../irule';

import{ArticleService} from '../../services/article.service';

declare var $:any;//Required for jquery use

@Component({
  selector: 'app-manage-article-category',
  templateUrl: './manage-article-category.component.html',
  styleUrls: ['./manage-article-category.component.css'],
  encapsulation:ViewEncapsulation.None
})
export class ManageArticleCategoryComponent implements OnInit ,IRule {

  userName='';
  navigationsType=[];

  url:any=AppSettings.API_ENDPOINT;

  category_articles:any=[];

  msg:any;

   toastr:any;

  _router:any;

   record_empty:number =0;

   record_offset:number = 0;

   delCat:number=0; 

   token:any='';

   articleCaregoryList = [];

   searchTxt:string = '';
   categoryId:number = 0;
   categoryAddTxt:string = '';
   categoryOldTxt:string = '';
   categoryInputLabel:string = 'Add New';

  

   per_page:number=10;

   loader_image:boolean=true;
 
   notification:any=[];

  @HostBinding('style.width') public width: string = '100%'; //for edge browser design issue


  constructor(private articleService:ArticleService,msg:MessageService, toastr: ToastrService,homeservice:HomeService, _router: Router) {



  

    this.msg = msg;
    this.toastr = toastr;
    this._router =_router;

  }

  ngOnInit() {

  	try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);


      this.token = tokenA.token;


      let data={
        token:tokenA.token,
        limit:this.per_page,
        'page':'settings'
      	//offset:this.record_offset
      }
       
        this.loader_image =true
      
      	this.categoryList(data);

    }catch(error){

      this._router.navigate(['/login']);

    }


  }


categoryLazyList(offset)
  {
    

    let data={
      token:this.token,
      search:this.searchTxt,
      limit:this.per_page,
      offset:offset,
      'page':'settings'
    }
   
  this.loader_image =true
  this.record_empty =1;
  this.categoryList(data);

  }
  ngAfterViewInit(){

 


    $(window).on("scroll", function() {

       
      


      if(this._router.url == '/settings/manage-article-category'){





        if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
          



           if(this.record_empty == 0){

              this.record_offset+=this.per_page;

             
              this.categoryLazyList(this.record_offset);

            }
          

        }




      }

 



    }.bind(this));



  	$(document).ready(function(){


  		$('input').blur(function(event) {
            var inputValue = this.value;
            if (inputValue) {
                this.classList.add('value-exists');
            } else {
                this.classList.remove('value-exists');
            }
        });

        $('a.tooltip-custom').click(function(){
        		$('.approver-popup > input ').addClass('value-exists');
        });

         $('body').on('click','.tooltip-custom',function(){

         	$(this).tooltip("hide");

       	 });


	       let tl:any= $('body');
	         tl.tooltip({
	          trigger: "hover" ,
	          selector: '.tooltip-custom'
	      });

	      tl.on('show.bs.tooltip', () => {
	        //$('.tooltip-custom').not(this).remove();
	      });

	      //scrolltotop
	      $(window).scroll(function(){
				if ($(this).scrollTop() > 1) {
					$('#yt-totop').css({bottom:"25px"});
				} else {
				$('#yt-totop').css({bottom:"-50px"});
				}
			});
			
			$('#yt-totop').click(function(){
				$('html, body').animate({scrollTop: '0px'}, 800);
					return false;
			});
 

  	}.bind(this));
  }

  addcategoryList(data){

 

    this.articleService.getCategoryList(data).subscribe( (res)=>{

    

      if(res.status=='success'){

    
         this.loader_image =false;

         let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

          if(!tokenA) throw 'Error in parse';

          if(!JSON.parse(tokenA)) throw 'Error in json parse';

          tokenA = JSON.parse(tokenA);


          this.token = tokenA.token;


          let data={
            token:tokenA.token,
            limit:this.per_page,
            'page':'settings'
            //offset:this.record_offset
          }
          this.articleCaregoryList =[]
     
         this.categoryList(data);

      

      }else{        
        this.toastr.error(res.message, '', {timeOut: 5000});
      }
  });



  }



  categoryList(data)
  {

      

  		this.articleService.getCategoryList(data).subscribe( (res)=>{

      
        if(res.status=='success'){


          this.loader_image =false;

          if(res.category !=undefined ){

            this.record_empty = 0;

          } else{

           this.record_empty =1;

          }

         
          if(this.articleCaregoryList.length==0){
             
            this.articleCaregoryList=res.category;  
            

          } else if(res.category !=undefined ){


            res.category.forEach(element => {

              this.articleCaregoryList.push(element);
              
            });

          }
         
          
          this.userName=res.user.name;

          this.navigationsType=res.navigation;

          this.notification =res.notification;
            
          this.broadcast_menu();
        
        

        }else{        
          this.toastr.error(res.message, '', {timeOut: 5000});
        }
    });

  }


  searchCategoryList()
  {
  	let data={
        token:this.token,
        search:this.searchTxt,
        limit:this.per_page,
        'page':'settings'
      }
     
    this.loader_image =true
    this.articleCaregoryList=[];
    this.record_offset=0;
    this.categoryList(data);
     

  }

  addCategoryList()
  {
    let msg = "";
    
    this.record_offset =0;


  	if (this.categoryAddTxt.trim() != '' && (this.categoryOldTxt.trim() != this.categoryAddTxt.trim())) {
	  	let data={
	        token:this.token,
	        name:this.categoryAddTxt,
          // limit:this.per_page,
          'page':'settings'
	      	//offset:this.record_offset 
	      }

	    msg =  'Category added successfully';

	    if(this.categoryId > 0 && this.categoryInputLabel == 'Edit')
	  	{
        
        data = Object.assign(data, {'id' : this.categoryId,});
        msg = 'Category updated successfully';

        let catI = this.articleCaregoryList.findIndex( (elm) => { return  elm.id == this.categoryId});
          
        this.articleCaregoryList[catI].value= this.categoryAddTxt;
         
        
	  	} 

	    this.addcategoryList(data);
	    this.categoryAddTxt = '';
	    this.categoryInputLabel = 'Add New';  
	    //this.categoryId = 0; 
	    this.toastr.success(msg, '', {timeOut: 5000});

	    //hide the popup after successfull addition
	    $('#create_article_category_popup').modal('hide');
	} else {
		msg = 'Field can not be blank / same !';
		this.toastr.error(msg, '', {timeOut: 5000});
	}

  }

  deleteCategoryList(){

    let data={
      token:this.token,
      reqData:{
        id:this.delCat, 
        archive:true,
        'page':'settings'
      }
     
      //offset:this.record_offset
    }


    this.articleService.removeCategory(data).subscribe( (res)=>{
      
      

      if(res.status=='success'){

        let catI = this.articleCaregoryList.findIndex( (elm) => { return  elm.id ==  this.delCat});
          
        this.articleCaregoryList.splice(catI,1);

        this.delCat =0;


      }else{
        this.delCat =0;
      }

    });
     


  }
  isdeleteCategoryList(cat){
    
    this.delCat = cat.id;

    
    $('#success-popup').modal('show');

  




  }

  editCategoryList(cat)
  {


    this.categoryAddTxt = cat.value;
    this.categoryOldTxt = cat.value;
    this.categoryId = cat.id;
    this.categoryInputLabel = 'Edit'; 



    //show the popup after successfull addition
	$('#create_article_category_popup').modal('show');
  }


  broadcast_menu(){
    
    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType});
   }


}
